import classNames from 'classnames/bind';
import { gql } from '@apollo/client';
import styles from './AcfFeatureComparison.module.scss';
import { Card, Heading, Grid, List, RichText, Image } from '@/components';

let cx = classNames.bind(styles);

export default function AcfFeaturecomparison(props) {
	const { featureComparison, attributes, id } = props;
	const className = attributes.className?.split(' ') || [];
	return (
		<Card id={attributes.anchor} className={cx(['ns_feature-comparison', 'feature-comparison', ...className])}>
			{featureComparison.categories.map((category, index) => (
				<Grid key={`feature-comparison-grid-${id}-${index}`}>
					<div className={cx('feature-comparison-category')}>
						<div className={cx('feature-comparison-avatar-container')}>
							<Image className={cx('feature-comparison-avatar')} image={category.avatar} width={86} height={86} />
							<span className={cx('feature-comparison-avatar-label')}>
								<RichText html={category.avatarLabel} />
							</span>
						</div>
							<RichText className={cx(['ns_feature-comparison-heading', 'feature-comparison-heading'])} elem={category.headingElement} html={category.heading} />
						<List elem='ul' listStyle={category.featureListIcon}>
							{category.features.map((feature, index) => (
								<li key={`feature-comparison-list-${id}-${index}`}>
									<RichText html={feature.featureText} />
								</li>
							))}
						</List>
					</div>
				</Grid>
			))}
		</Card>
	);
}

AcfFeaturecomparison.fragments = {
	key: `AcfFeatureComparisonFragment`,
	entry: gql`
		${Image.fragments.entry}
		fragment AcfFeatureComparisonFragment on AcfFeaturecomparison {
			attributes {
				anchor
				className
			}
			featureComparison {
				categories {
					avatar {
						...ImageFragment
					}
					avatarLabel
					featureListIcon
					features {
						featureText
					}
					heading
          headingElement
				}
			}
		}
	`,
};

AcfFeaturecomparison.config = {
	name: 'AcfFeaturecomparison',
};
AcfFeaturecomparison.displayName = 'AcfFeaturecomparison';
